import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.OUT.enumeration<
    graphql.schema.ProcessItemType,
    ents.core.relay.processes.Item.Type
  >({
    [graphql.schema.ProcessItemType.Entity]:
      ents.core.relay.processes.Item.Type.RecordModel,
    [graphql.schema.ProcessItemType.Allocation]:
      ents.core.relay.processes.Item.Type.Allocation,
    [graphql.schema.ProcessItemType.Pool]:
      ents.core.relay.processes.Item.Type.Pool,
    [graphql.schema.ProcessItemType.Report]:
      ents.core.relay.processes.Item.Type.Report,
    [graphql.schema.ProcessItemType.Importer]:
      ents.core.relay.processes.Item.Type.Importer,
    [graphql.schema.ProcessItemType.Unknown]:
      ents.core.relay.processes.Item.Type.Unknown,
  }),
  graphql.transformers.IN.enumeration<
    ents.core.relay.processes.Item.Type,
    graphql.schema.ProcessItemType
  >({
    [ents.core.relay.processes.Item.Type.RecordModel]:
      graphql.schema.ProcessItemType.Entity,
    [ents.core.relay.processes.Item.Type.Allocation]:
      graphql.schema.ProcessItemType.Allocation,
    [ents.core.relay.processes.Item.Type.Pool]:
      graphql.schema.ProcessItemType.Pool,
    [ents.core.relay.processes.Item.Type.Report]:
      graphql.schema.ProcessItemType.Report,
    [ents.core.relay.processes.Item.Type.Importer]:
      graphql.schema.ProcessItemType.Importer,
    [ents.core.relay.processes.Item.Type.Unknown]:
      graphql.schema.ProcessItemType.Unknown,
  }),
)
